import { render, staticRenderFns } from "./ReadingTask1.vue?vue&type=template&id=3ae5a8a0&scoped=true&"
import script from "./ReadingTask1.vue?vue&type=script&lang=ts&"
export * from "./ReadingTask1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae5a8a0",
  null
  
)

export default component.exports